<template>
  <div class="pos-container">
    <template v-if="showCloseShift">
      <PosHeader />
      <div
        class="pos-checkout-wrapper mb-3 bg-white rounded-20"
        style="height:calc(100vh - 170px)"
      >
        <div class="row h-100">
          <div class="col-lg-7">
            <PosShiftCloseCalculator
              v-if="paymentTypes.cashPayments"
              class="mx-auto"
            />
          </div>
          <div class="col-lg-5">
            <ul class="list-unstyled card-payment-contianer">
              <li
                v-for="(PaymentItem, PaymentIndex) in getShiftClosePaymentModes"
                :key="PaymentIndex"
                class="col-12 mb-3"
              >
                <div
                  v-if="String(PaymentItem.pm_id) === '1'"
                  class="input-material"
                >
                  <!-- <input
                  :value="PaymentItem.amount"
                  @input="onPosShiftClosePaymentHandler({ event: $event, name: 'amount', index: PaymentIndex, value: $event.target.value })"
                  type="text"
                  class="form-control"
                />-->
                  <input
                    disabled
                    placeholder="."
                    :value="PaymentItem.amount"
                    type="number"
                    step="any"
                    class="form-control bg-white"
                  />
                  <label
                    :for="PaymentItem.pm_payment_mode"
                    class="d-block small text-muted"
                    >{{ PaymentItem.pm_payment_mode }}</label
                  >
                </div>
                <div v-else>
                  <label
                    class="d-block small text-muted"
                    :for="PaymentItem.pm_payment_mode"
                    >{{ PaymentItem.pm_payment_mode }}</label
                  >
                  <div class="row">
                    <div class="col-6">
                      <div class="input-material">
                        <input
                          class="form-control bg-white"
                          type="number"
                          :id="`${PaymentIndex}_noofSlip`"
                          :name="`${PaymentIndex}_noofSlip`"
                          :value="PaymentItem.no_of_slips"
                          placeholder="."
                          @focus="onClickInputHandler(PaymentItem, 'slip')"
                          @input="
                            onPosShiftClosePaymentHandler({
                              event: $event,
                              name: 'no_of_slips',
                              index: PaymentIndex,
                              value: $event.target.value,
                            })
                          "
                        />
                        <label>No Of Slips</label>
                        <VkeyboardFloat
                          :ID="`${PaymentIndex}_noofSlip`"
                          :onClickFun="
                            () => onClickShowKeyboard(PaymentItem, 'slip')
                          "
                        />
                        <Vkeyboard
                          :inputName="`${PaymentIndex}_noofSlip`"
                          :showOrHide="PaymentItem.keyboardnsActive"
                          :initialValue="String(PaymentItem.no_of_slips)"
                          :keyBoardType="'numeric'"
                          @onChangeEvent="() => {}"
                          @onKeyEnter="onCloseKeyboard(PaymentItem, 'slip')"
                          @changeKeyboardInput="
                            onPosShiftClosePaymentHandler({
                              event: $event,
                              name: 'no_of_slips',
                              index: PaymentIndex,
                              value: $event,
                            })
                          "
                          @onClickClose="onCloseKeyboard(PaymentItem, 'slip')"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-material ml-1 h-auto">
                        <input
                          class="form-control bg-white"
                          type="number"
                          :id="`${PaymentIndex}_tamount`"
                          :name="`${PaymentIndex}_tamount`"
                          :value="PaymentItem.amount"
                          placeholder="."
                          @focus="onClickInputHandler(PaymentItem, 'amount')"
                          @input="
                            onPosShiftClosePaymentHandler({
                              event: $event,
                              name: 'amount',
                              index: PaymentIndex,
                              value: $event.target.value,
                            })
                          "
                        />
                        <label>Amount</label>
                        <VkeyboardFloat
                          :ID="`${PaymentIndex}_tamount`"
                          :onClickFun="
                            () => onClickShowKeyboard(PaymentItem, 'amount')
                          "
                        />
                        <Vkeyboard
                          :inputName="`${PaymentIndex}_tamount`"
                          :showOrHide="PaymentItem.keyboardtmActive"
                          :initialValue="String(PaymentItem.amount)"
                          :keyBoardType="'numeric'"
                          @onChangeEvent="() => {}"
                          @onKeyEnter="onCloseKeyboard(PaymentItem, 'amount')"
                          @changeKeyboardInput="
                            onPosShiftClosePaymentHandler({
                              event: $event,
                              name: 'amount',
                              index: PaymentIndex,
                              value: $event,
                            })
                          "
                          @onClickClose="onCloseKeyboard(PaymentItem, 'amount')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="col-12 mb-4">
                <label for="Total" class="d-block small text-muted"
                  >Total</label
                >
                <input
                  type="text"
                  :value="getUserShiftPaymentGrandTotal"
                  disabled
                  class="form-control bg-white"
                />
              </li>
            </ul>
            <!-- <div class="card-payment-contianer" v-if="paymentTypes.creditNDebit">
            <h6 class="mb-3">{{ $t('payBy') }} {{ $t('creditDebit') }}</h6>
            <div>
              <input type="text" v-model="no_of_slips" placeholder="Number of Slips" class="mb-2" />
              <input type="text" v-model="totalCardAmount" placeholder="Total Amount" />
            </div>
            <img
              src="@/assets/img/pos/card-payment.png"
              height="auto"
              width="245"
              class="mx-auto d-block mt-5"
            />
          </div>-->

            <!-- <div class="col-6 d-flex align-items-center mb-3">
        <div class="mr-2">Credit Card :</div>
        <div>
          <input type="text" />
        </div>
      </div>
      <div class="col-6 d-flex align-items-center mb-3">
        <div class="mr-2">Debit Card :</div>
        <div>
          <input type="text" />
        </div>
      </div>
      <div class="col-12 d-flex justify-content-center border-top">
        <div class="d-flex align-items-center mt-3">
          <div class="mr-2">Total INR :</div>
          <div>
            <input type="text" />
          </div>
        </div>
          </div>-->
          </div>
        </div>
        <div ref="onPrint" class="d-none">
          <div v-html="EjsData"></div>
        </div>
      </div>
      <div class="text-center mx-auto">
        <router-link
          to
          v-on:click.native="showRemarkPopUp()"
          class="btn-blue-lg ml-2"
          >Submit</router-link
        >
        <!-- <button v-on:click="onLogout()" class="btn-blue-lg ml-2">Logout</button> -->
        <button v-on:click="OnSkip()" class="btn-blue-lg ml-2">Skip</button>
      </div>
      <b-modal id="remarkCLoseShift" title="Remark" hide-footer>
        <div>
          <div class="mt-4 mb-4">
            <b-textarea v-model="Remark" placeholder="Remark"></b-textarea>
          </div>
          <button
            class="btn btn-blue w-100 px-2"
            @click.prevent.stop="onSubmit()"
          >
            Submit
          </button>
        </div>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import PosShiftCloseCalculator from "@/components/Partials/posShiftCloseCalculator.vue";
import PosHeader from "@/components/Partials/posHeader.vue";
import Printd from "printd";
import PosService from "@/services/PosService.js";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { createQueryString } from "@/services/ApiHelper";
import { BASEURL } from "@/config/index";
import moment from "moment";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  components: {
    PosHeader,
    PosShiftCloseCalculator,
    VkeyboardFloat,
    Vkeyboard,
  },
  name: "ShiftClose",
  data() {
    return {
      no_of_slips: 0,
      totalCardAmount: 0,
      LoggedUserId: null,
      CollectionData: [],
      FinalTotal: {},
      EjsData: null,
      paymentTypes: {
        cashPayments: true,
        creditNDebit: false,
        cashless: false,
        splitPayments: false,
        couponNPromotions: false,
        vouchers: false,
        loyaltyCard: false,
      },
      showCloseShift: false,
      Remark: "",
    };
  },
  computed: {
    ...mapGetters(["getUserShiftPaymentGrandTotal"]),
    userRole() {
      return this.secureStore.get("USINFO").role_name;
    },
    shiftDetails() {
      return this.$store.getters.SHIFT_DETAILS;
    },
    totalCashCollected() {
      return this.$store.getters.TOTAL_CASH_COLLECTED;
    },
    GET_CASH_DENOMINATION() {
      return this.$store.getters.GET_CASH_DENOMINATION;
    },
    getShiftClosePaymentModes() {
      let tempArray = this.$store.getters.getUserShiftPaymentTypes || [];

      tempArray.map((x) => {
        x["keyboardnsActive"] = false;
        x["keyboardtmActive"] = false;
      });

      console.log("tempArray", tempArray);
      return tempArray;
    },
  },
  watch: {
    "$store.getters.TOTAL_CASH_COLLECTED"(newVal, oldval) {
      this.onPosShiftClosePaymentCash(newVal);
    },
  },
  beforeMount() {
    const { user_id, cinema_id } = this.secureStore.get("USINFO");
    this.LoggedUserId = user_id;
    this.$store.dispatch("getPosUsersShiftPaymentTypes");
    this.getPosUserCollection();
    console.log(
      CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME,
      CLIENT_NAME.EMPIRE,
      this.CLIENT_SETUP_NAME
    );

    // setTimeout(() => {
    //   // this.PrintPosUserCollection(true);
    //   this.PrintShiftCloseInvoiceSummary(true);
    // }, 2000);
  },
  mounted() {
    let checkClient = this.authorizeClient(CLIENT_NAMES_OBJ.empire_combo);
    if (checkClient) {
      this.PrintShiftCloseInvoiceSummary(true).then((value) => {
        console.log("value from close shift", value);
        this.Remark = `Auto Close Shift`;
        this.onSubmit();
      });
    } else {
      this.showCloseShift = true;
    }
  },
  methods: {
    moment: moment,
    ...mapActions([
      "onPosShiftClosePaymentCash",
      "onPosShiftClosePaymentHandler",
    ]),
    onCloseKeyboard(pm, type) {
      pm["keyboardtmActive"] = false;
      pm["keyboardnsActive"] = false;
      this.$forceUpdate();
    },
    onClickShowKeyboard(pm, type) {
      console.log("onClickShowKeyboard pm", pm);
      this.getShiftClosePaymentModes.map((x) => {
        x["keyboardtmActive"] = false;
        x["keyboardnsActive"] = false;
      });

      if (type == "amount") {
        pm["keyboardtmActive"] = !pm["keyboardtmActive"];
      } else if (type == "slip") {
        pm["keyboardnsActive"] = !pm["keyboardnsActive"];
      }
      this.$forceUpdate();
    },
    onClickInputHandler(pm, type) {
      if (
        this.getShiftClosePaymentModes.some(
          (y) => y.keyboardtmActive == true || y.keyboardnsActive == true
        )
      ) {
        this.getShiftClosePaymentModes.map((x) => {
          x["keyboardtmActive"] = false;
          x["keyboardnsActive"] = false;
        });

        if (type == "amount") {
          pm["keyboardtmActive"] = true;
        } else if (type == "slip") {
          pm["keyboardnsActive"] = true;
        }
        this.$forceUpdate();
      }
    },

    getPosUserCollection(isPrint = false) {
      let payload = {
        show_current_shift_collection: "Y",
        user_id: this.LoggedUserId,
        isPrint: isPrint,
      };
      let loader = this.$loading.show();
      PosService.getPosUserCollection(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && !isPrint) {
            if (!isPrint) {
              this.CollectionData = data.Records;
              this.FinalTotal = data.FinalCollection;
            }
          } else if (isPrint) {
            this.EjsData = data;

            this.$nextTick(() => {
              loader.hide();
              const p = new Printd();
              if (this.$refs.onPrint && this.EjsData != null) {
                // p.print(this.$refs.onPrint, this.EjsData);
                return;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    PrintShiftCloseInvoiceSummary(isPrint = true) {
      let payload = {
        user_id: this.LoggedUserId,
        fromDate: moment(this.from_date || new Date()).format("YYYY-MM-DD"),
        toDate: moment(this.to_date || new Date()).format("YYYY-MM-DD"),
        isCurrentShift: "Y",
        isPrint: isPrint,
      };

      return PosService.getShiftCloseInvoiceSummary(payload)
        .then((response) => {
          const { data } = response;
          // if (data.ejsTicket) {
          // if (
          //   this.show_current_shift_collection == "N" &&
          //   (!this.from_date || !this.to_date)
          // ) {
          //   return this.$toasted.show("Please Select Dates");
          // } else {
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            let loader = this.$loading.show();
            // try {
            const queryString = createQueryString(payload);
            console.log(this.$socket, "socket");
            if (this.$socket && isPrint) {
              console.log("socket_close_invoked");
              this.$socket.emit("on_print_ticket", {
                baseurl: BASEURL,
                ttype: "pos_collection_summary",
                user_id: this.LoggedUserId,
                queryString: queryString,
              });
              console.log("socket_close_invoked_123");
            }
            console.log("outside_socket");
            loader.hide();
            // } catch (err) {
            //   console.log("ERROR in SOcket", err);
            // } finally {
            //   setTimeout(() => loader.hide(), 1000);
            // }
          } else {
            console.log("printing here");
          }
          // }
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    PrintPosUserCollection(isPrint = true) {
      let payload = {
        show_current_shift_collection: "Y",
        user_id: this.LoggedUserId,
        isPrint: isPrint,
      };

      // else {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        let loader = this.$loading.show();
        try {
          const queryString = createQueryString(payload);
          if (this.$socket) {
            setTimeout(() => {
              console.log("printData12345");
              this.$socket.emit("on_print_ticket", {
                baseurl: BASEURL,
                ttype: "pos_collection_summary",
                user_id: this.LoggedUserId,
                queryString: queryString,
              });
              console.log("printData");
            }, 2000);
          }
        } catch (err) {
          console.log("ERROR in SOcket", err);
        } finally {
          setTimeout(() => loader.hide(), 1000);
        }
      } else {
        console.log("in else");
        this.getPosUserCollection(true);
      }
      // }
    },
    onSelectPaymentType: function(name) {
      // this.paymentTypes[name] =true
      Object.keys(this.paymentTypes).map((x) => {
        // console.log('x :', x);
        if (x == name) {
          this.paymentTypes[x] = this.paymentTypes[x]
            ? this.paymentTypes[x]
            : !this.paymentTypes[x];
        } else {
          this.paymentTypes[x] = false;
        }
      });
    },
    OnSkip: function() {
      if (this.userRole == "FnB POS Operator") {
        this.$router.push({
          path: "pos-fnb-login",
        });
      } else {
        this.$router.push({
          path: "pos-login",
        });
      }
      var myItem = null;
      if (localStorage.getItem("ECR_INFO")) {
        myItem = localStorage.getItem("ECR_INFO");
      }
      window.localStorage.clear();
      if (myItem) {
        localStorage.setItem("ECR_INFO", myItem);
      }
      this.$cookie.delete("BRHSID");
      this.$store.dispatch("clearShiftData");
      this.$store.dispatch("SET_TOTAL_CASH_COLLECTED", 0);
    },
    onLogout: async function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Pos User selected logout button`,
        page_name: "close shift",
        api_name: "",
      });
      if (this.userRole == "FnB POS Operator") {
        this.$router.push({
          path: "pos-fnb-login",
        });
      } else {
        this.$router.push({
          path: "pos-login",
        });
      }
      // window.localStorage.removeItem("JWT_TOKEN");
      await this.$store.dispatch("onUserShiftQuit", {});
      await this.$store.dispatch("onResetFnBStoreState");

      var myItem = null;
      if (localStorage.getItem("ECR_INFO")) {
        myItem = localStorage.getItem("ECR_INFO");
      }
      window.localStorage.clear();
      if (myItem) {
        localStorage.setItem("ECR_INFO", myItem);
      }
      this.$cookie.delete("BRHSID");
    },
    showRemarkPopUp() {
      this.$bvModal.show("remarkCLoseShift");
    },
    onSubmit: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Pos User selected submit for close shift with total cash collected as : ${this.getUserShiftPaymentGrandTotal} `,
        page_name: "close shift",
        api_name: "",
      });
      if (!this.Remark) {
        this.$toasted.show("Please Enter Remark");
      }
      // let payload = {
      //   operator_type:
      //     this.userRole == "FnB POS Operator"
      //       ? "pos-fnb"
      //       : this.userRole == "POS Operator"
      //       ? "pos-booking"
      //       : "box-office-fnb", //'pos-fnb' // 'box-office-fnb'
      //   shift_id: this.shiftDetails.shift_id,
      //   manager_user_id: this.shiftDetails.manager_user_id,
      //   operator_user_id: this.shiftDetails.operator_user_id,
      //   currency_id: this.shiftDetails.currency_id,
      //   scr_total_amount_collected:
      //     parseFloat(this.totalCashCollected) +
      //     parseFloat(this.totalCardAmount),
      //   scr_approval_status: false,
      //   scr_is_active: false
      // };
      let payload = {
        operator_type:
          this.userRole == "FnB POS Operator"
            ? "pos-fnb"
            : this.userRole == "POS Operator"
            ? "pos-booking"
            : "box-office-fnb", //'pos-fnb' // 'box-office-fnb'
        shift_id: this.shiftDetails.shift_id,
        manager_user_id: this.shiftDetails.manager_user_id,
        operator_user_id: this.shiftDetails.operator_user_id,
        currency_id: this.shiftDetails.currency_id,
        scr_total_amount_collected: this.getUserShiftPaymentGrandTotal,
        scr_approval_status: false,
        scr_is_active: false,
        //
        shiftClosePayments: this.$store.getters.getUserShiftPaymentTypes,
        cashDenomination: this.GET_CASH_DENOMINATION,
        Remark: this.Remark,
        checkSkip: CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME,
      };

      PosService.onCloseShift(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$store.dispatch("userPosShiftClose", {});
            this.$toasted.show(data.message);
            var myItem = null;
            if (localStorage.getItem("ECR_INFO")) {
              myItem = localStorage.getItem("ECR_INFO");
            }
            window.localStorage.clear();
            if (myItem) {
              localStorage.setItem("ECR_INFO", myItem);
            }
            this.$cookie.delete("BRHSID");
            this.$store.dispatch("clearShiftData");
            this.$store.dispatch("SET_TOTAL_CASH_COLLECTED", 0);
            if (this.userRole == "FnB POS Operator") {
              this.$router.push({
                path: "pos-fnb-login",
              });
            } else {
              this.$router.push({
                path: "pos-login",
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posCloseShift.vue